<template>
  <div class="i-coaching-upsell-careers">
    <div class="top">
      <iBaseHeader
        highlight-text=""
        text="Get Expert Help"
        font-size-text="18px"
        align="start"
      />
      <div class="text">Supercharge your career with a personalized career coach.</div>
      <iBaseButton
        class="cta"
        v-bind="BUTTON_STYLE"
        text="Schedule a call"
        @clicked="linkToCoachSelection"
      />
    </div>
    <div class="bottom">
      <img
        :src="ImageCoaching"
        alt="Coaching Image"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { black, sorbus400 } from "@/styles/colors"

import linkToCoachSelection from "@/composables/linkToCoachSelection"

import iBaseHeader from "@/components/base/BaseHeader.vue"
import iBaseButton from "@/components/base/BaseButton.vue"

// ASSETS
import ImageCoaching from "@/assets/home/coaching-upsell.png"

// CONSTANTS
const BUTTON_STYLE = {
  size: "small",
  fontWeight: "500",
  width: "100%",
  backgroundColor: sorbus400,
  borderRadius: "8px",
  textColor: black,
  padding: "12px 12px"
}
</script>

<style lang="scss" scoped>
.i-coaching-upsell-careers {
  @include flex(column, start, stretch, $gap: 25px);
  @include border-radius-lg;

  background-color: $black50;
  width: 100%;
  padding: 20px;
  margin-top: 30px;

  @media screen and (min-width: $breakpoint-md) {
    @include flex(row, end, center, $gap: 40px);

    border: 1px solid $zumthor100;
    background-color: transparent;
    padding: unset;
    padding-top: 20px;
    padding-right: 10px;
  }

  @media screen and (min-width: $breakpoint-xl) {
    gap: 15px;
  }

  .top {
    @include flex(column, start, start, $gap: 15px);

    max-width: 100%;

    @media screen and (min-width: $breakpoint-md) {
      max-width: 40%;
    }

    .text {
      @include text-md;

      font-weight: 500;
      color: $pickle-bluewood800;
    }

    .cta {
      margin-top: 10px;
    }
  }

  .bottom {
    width: 100%;

    @include flex(column, start, center);

    @media screen and (min-width: $breakpoint-md) {
      width: 45%;
      height: 330px;
      overflow: hidden;
    }
  }
}
</style>
